import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import queryString from 'query-string';
import { sanitizeLocation } from '../../../routes/searchResult/refinements/services/sanitize';
import {
  locationsGenerator,
  floorAreaGenerator,
  landAreaGenerator,
  currentLocationGenerator,
  activeSortGenerator,
  keywordsGenerator,
  searchWithinGenerator,
  parkingSpacesGenerator,
  energyEfficiencyGenerator,
  tenureTypeGenerator,
  priceGenerator,
  propertyTypesGenerator,
} from '../../../routes/searchResult/refinements/services/queryGenerator';

export function locationUrlGenerator(locations = []) {
  const validLocations = locations.map(sanitizeLocation).filter(Boolean);
  const singleValidLocation = validLocations.length === 1;

  return singleValidLocation ? validLocations[0] : '';
}

function addCommas(string) {
  return string.replace(/(%2c)+/gi, ',');
}

export function priceUrlGenerator(minPrice, maxPrice) {
  const priceQuery = priceGenerator(minPrice, maxPrice);
  return queryString.stringify(priceQuery);
}

export function propertyTypesUrlGenerator(propertyTypes) {
  return propertyTypes.map(propertyType => propertyType.replace(/ /g, '+')).join('-');
}

export function searchPathGenerator(channel, location, propertyTypes = []) {
  const singularPropertyType = propertyTypes.length === 1 && propertyTypes[0];

  if (isEmpty(propertyTypes) && isEmpty(location)) {
    return `/${channel}/`;
  }

  const path = [channel, location, singularPropertyType].filter(Boolean).join('/').replace(/\*/g, '');

  return `/${path}/`;
}

export function generateSearchUrl(URLPathFields, URLQueryFields = {}) {
  const locationInPath = locationUrlGenerator(URLPathFields.locations);
  const locationsQuery = locationsGenerator(URLPathFields.locations);
  const parkingSpacesQuery = parkingSpacesGenerator(URLQueryFields.numParkingSpaces);
  const searchWithinQuery = searchWithinGenerator(URLQueryFields.searchWithin);
  const activeSortQuery = activeSortGenerator(URLQueryFields.sortObject);
  const keywordsQuery = keywordsGenerator(URLQueryFields.keywords);
  const energyEfficiencyQuery = energyEfficiencyGenerator(URLQueryFields.energyEfficiency);
  const floorAreaQuery = floorAreaGenerator(URLQueryFields.minFloorArea, URLQueryFields.maxFloorArea);
  const siteAreaQuery = landAreaGenerator(URLQueryFields.minSiteArea, URLQueryFields.maxSiteArea);
  const currentLocationQuery = currentLocationGenerator(URLQueryFields.currentLocation);
  const tenureTypeQuery = tenureTypeGenerator(URLPathFields.tenureType);
  const priceQuery = priceGenerator(URLPathFields.minPrice, URLPathFields.maxPrice);
  const propertyTypesQuery = propertyTypesGenerator(URLPathFields.propertyTypes);
  const queryObject = merge(
    locationsQuery,
    floorAreaQuery,
    siteAreaQuery,
    currentLocationQuery,
    parkingSpacesQuery,
    searchWithinQuery,
    activeSortQuery,
    keywordsQuery,
    energyEfficiencyQuery,
    tenureTypeQuery,
    priceQuery,
    propertyTypesQuery,
  );
  const search = queryString.stringify(queryObject);
  const searchWithLocationCommas = addCommas(search);

  return {
    pathname: searchPathGenerator(URLPathFields.channel, locationInPath, URLPathFields.propertyTypes),
    search: searchWithLocationCommas,
  };
}
